import React, { memo, SVGProps } from 'react'

// this is the only icon that is allowed to have this viewbox
// because it's used for correct alignment in DropdownButton
export const Dropdown = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.00094 15.0244C6.18526 15.0244 6.36958 14.9543 6.50974 14.8132L11.1177 10.2052C11.399 9.92389 11.399 9.46789 11.1177 9.18661C10.8365 8.90533 10.3805 8.90533 10.0992 9.18661L5.99998 13.2858L1.90078 9.18661C1.6195 8.90533 1.1635 8.90533 0.882225 9.18661C0.600945 9.46789 0.600945 9.92389 0.882225 10.2052L5.49022 14.8132C5.63038 14.9533 5.8147 15.0244 5.99902 15.0244H6.00094Z"
      fill="currentColor"
    />
  </svg>
))
